"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  navbar: {
    height: '60px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    boxShadow: '0 4px 6px -6px black',
    backgroundColor: '#fff'
  },
  toolbar: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    minHeight: '50px',
    height: '60px'
  },
  navContent: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1400px',
    height: '60px'
  },
  brand: {
    width: 'auto',
    maxHeight: '50px',
    ':hover': {
      cursor: 'pointer'
    }
  },
  menuIcon: {
    fontSize: '24px',
    color: 'black',
    '@media (max-width: 1400px)': {
      paddingRight: '20px'
    },
    ':hover': {
      cursor: 'pointer'
    }
  }
};
exports.default = _default;

//# sourceMappingURL=Navbar.css.js.map